// extracted by mini-css-extract-plugin
module.exports = {"component":"TextAnnotationWorkspace--component","editorPanel":"TextAnnotationWorkspace--editorPanel","annotationsPanel":"TextAnnotationWorkspace--annotationsPanel"};